import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox-on",
  "use": "checkbox-on-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"checkbox-on\"><path fill-rule=\"evenodd\" d=\"M0 1.792C0 .802.808 0 1.792 0h14.416C17.198 0 18 .808 18 1.792v14.416c0 .99-.808 1.792-1.792 1.792H1.792C.802 18 0 17.192 0 16.208V1.792zm6.572 12.54l8.555-9.41L13.674 3.6l-7.168 7.886-2.417-2.417L2.7 10.46l3.872 3.873z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol